import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

function EditRequestFormFieldDisable({ formData, name, required }) {
  return (
    <div className="flex flex-col mb-3">
      <label 
        className="mb-1 mt-[0.3vh] inline-block font-['Open_Sans'] text-[12px] font-bold text-[#212529]"
      >
        <FormattedMessage id={name} />
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>
      
      <input
        type="text"
        disabled
        readOnly
        value={formData || ''}
        data-cy={`${String(name).toLowerCase()}`}
        className="w-full bg-[#efefef] border border-[#ced4da] rounded-[4px] !h-[37px] !px-[12px] py-[6px] text-[14px] font-semibold font-['Open_Sans'] text-[rgba(0,0,0,0.38)] cursor-not-allowed transition-all"
      />
    </div>
  );
}

EditRequestFormFieldDisable.propTypes = {
  formData: PropTypes.any,
  name: PropTypes.string,
  required: PropTypes.bool,
};

EditRequestFormFieldDisable.defaultProps = {
  formData: '',
  name: '',
  required: false,
};

export default EditRequestFormFieldDisable;
